var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_134_2595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.30498 12.5604L9.66714 9.19088L6.30498 5.82138L7.34005 4.7863L11.7446 9.19088L7.34005 13.5955L6.30498 12.5604Z",
    fill: "#E9E9E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_134_2595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.6183,
    height: 17.6183,
    fill: "white",
    transform: "matrix(0 -1 -1 0 17.6172 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/RightArrow.7d3dd20ab30865e9731e1913afbc8894.svg";
export { ForwardRef as ReactComponent };